// constants
import * as C from '../../../constants';
// utilities
import { getTranslation } from '../../../utilities';
//////////////////////////////////////////////////

const REPORT_FILTER_DATE_OPERATION_DAYS = 'DAYS';
const REPORT_FILTER_DATE_OPERATION_HOURS = 'HOURS';
const REPORT_FILTER_DATE_OPERATION_WEEKS = 'WEEKS';
const REPORT_FILTER_DATE_OPERATION_MONTHS = 'MONTHS';

const REPORT_FILTER_DATE_LAST_NEXT_OPERATIONS = [
  REPORT_FILTER_DATE_OPERATION_DAYS,
  REPORT_FILTER_DATE_OPERATION_HOURS,
  REPORT_FILTER_DATE_OPERATION_WEEKS,
  REPORT_FILTER_DATE_OPERATION_MONTHS,
];

const newReportConditions = () => ({
  string: [
    {
      value: 'equal',
      name: getTranslation('labels.equal', 'Equal'),
    },
    {
      value: 'begin',
      name: getTranslation('labels.begin', 'Begin'),
    },
    {
      value: 'end',
      name: getTranslation('labels.end', 'End'),
    },
    {
      value: 'contain',
      name: getTranslation('labels.contain', 'Contain'),
    },
    {
      value: 'not_equal',
      name: getTranslation('labels.notEqual', 'Not Equal'),
    },
    {
      value: 'not_begin',
      name: getTranslation('labels.notBegin', 'Not Begin'),
    },
    {
      value: 'not_end',
      name: getTranslation('labels.notEnd', 'Not End'),
    },
    {
      value: 'not_contain',
      name: getTranslation('labels.notContain', 'Not Contain'),
    },
    {
      value: 'in',
      name: getTranslation('labels.in', 'In'),
    },
    {
      value: 'not_in',
      name: getTranslation('labels.notIn', 'Not In'),
    },
    {
      value: 'range',
      name: getTranslation('labels.range', 'Range'),
    },
  ],
  'string:array': [
    {
      value: 'contain',
      name: getTranslation('labels.contain', 'Contain'),
    },
  ],
  number: [
    {
      value: 'equal',
      name: getTranslation('labels.equal', 'Equal'),
    },
    {
      value: 'more',
      name: getTranslation('labels.more', 'More'),
    },
    {
      value: 'less',
      name: getTranslation('labels.less', 'Less'),
    },
    {
      value: 'not_equal',
      name: getTranslation('labels.notEqual', 'Not Equal'),
    },
    {
      value: 'not_more',
      name: getTranslation('labels.notMore', 'Not More'),
    },
    {
      value: 'not_less',
      name: getTranslation('labels.notLess', 'Not Less'),
    },
    {
      value: 'range',
      name: getTranslation('labels.range', 'Range'),
    },
  ],
  enum: [
    {
      value: 'equal',
      name: getTranslation('labels.equal', 'Equal'),
    },
    {
      value: 'not_equal',
      name: getTranslation('labels.notEqual', 'Not Equal'),
    },
  ],
  boolean: [
    {
      value: 'equal',
      name: getTranslation('labels.equal', 'Equal'),
    },
    {
      value: 'not_equal',
      name: getTranslation('labels.notEqual', 'Not Equal'),
    },
  ],
  selectMultiple: [
    {
      value: 'in',
      name: getTranslation('labels.in', 'In'),
    },
    {
      name: getTranslation('labels.notIn', 'Not In'),
      value: 'not_in',
    },
  ],
  date: [
    {
      value: 'HOURS',
      name: getTranslation('labels.Hours', 'Hours'),
    },
    {
      value: 'DAYS',
      name: getTranslation('labels.DAYS', 'Days'),
    },
    {
      value: 'WEEKS',
      name: getTranslation('labels.WEEKS', 'Weeks'),
    },
    {
      value: 'MONTHS',
      name: getTranslation('labels.MONTHS', 'Month'),
    },
    {
      value: 'date-range',
      name: getTranslation('labels.dateRange', 'Data Range'),
    },
  ],
  default: [],
});

const reportBooleanValues = () => ([
  {
    value: '',
    isDisabled: true,
    name: getTranslation('labels.chooseValue', 'Choose a value'),
  },
  {
    value: 'Yes',
    name: getTranslation('labels.yes', 'Yes'),
  },
  {
    value: 'No',
    name: getTranslation('labels.no', 'No'),
  },
]);

const carrierOperationValues = () => ([
  {
    value: '',
    isDisabled: true,
    name: getTranslation('labels.chooseValue', 'Choose a value'),
  },
  {
    name: 'A',
    value: 'A',
  },
  {
    name: 'B',
    value: 'B',
  },
  {
    name: 'C',
    value: 'C',
  },
]);

const commonFilterParams = {
  type: 'string',
};

const REPORT_FILTER_PARAMS = [
  {
    ...commonFilterParams,
    label: 'fax',
    name: C.FIELD_FAX,
  },
  {
    ...commonFilterParams,
    label: 'hmFlag',
    type: 'boolean',
    name: C.FIELD_HM_FLAG,
  },
  {
    ...commonFilterParams,
    label: 'phyZip',
    name: C.FIELD_PHY_ZIP,
  },
  {
    ...commonFilterParams,
    label: 'usMail',
    type: 'boolean',
    name: C.FIELD_US_MAIL,
  },
  {
    ...commonFilterParams,
    label: 'pcFlag',
    type: 'boolean',
    name: C.FIELD_PC_FLAG,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'migrant',
    name: C.FIELD_MIGRANT,
  },
  {
    ...commonFilterParams,
    label: 'phyCity',
    name: C.FIELD_PHY_CITY,
  },
  {
    ...commonFilterParams,
    label: 'addDate',
    type: C.FIELD_DATE,
    name: C.FIELD_ADD_DATE,
  },
  {
    ...commonFilterParams,
    label: 'dbaName',
    name: C.FIELD_DBA_NAME,
  },
  {
    ...commonFilterParams,
    label: 'opOther',
    name: C.FIELD_OP_OTHER,
  },
  {
    ...commonFilterParams,
    label: 'phyState',
    name: C.FIELD_PHY_STATE,
  },
  {
    ...commonFilterParams,
    label: 'oicState',
    name: C.FIELD_OIC_STATE,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'isExists',
    name: C.FIELD_IS_EXISTS,
  },
  {
    ...commonFilterParams,
    label: 'telephone',
    name: C.FIELD_TELEPHONE,
  },
  {
    ...commonFilterParams,
    type: 'number',
    label: 'dotNumber',
    name: C.FIELD_DOT_NUMBER,
  },
  {
    ...commonFilterParams,
    label: 'legalName',
    name: C.FIELD_LEGAL_NAME,
  },
  {
    ...commonFilterParams,
    label: 'phyStreet',
    name: C.FIELD_PHY_STREET,
  },
  {
    ...commonFilterParams,
    type: C.FIELD_DATE,
    label: 'mcs150Date',
    name: C.FIELD_MCS150DATE,
  },
  {
    ...commonFilterParams,
    label: 'mailingZip',
    name: C.FIELD_MAILING_ZIP,
  },
  {
    ...commonFilterParams,
    label: 'phyCountry',
    name: C.FIELD_PHY_COUNTRY,
  },
  {
    ...commonFilterParams,
    label: 'mailingCity',
    name: C.FIELD_MAILING_CITY,
  },
  {
    ...commonFilterParams,
    type: 'number',
    label: 'driverTotal',
    name: C.FIELD_DRIVER_TOTAL,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'privateOnly',
    name: C.FIELD_PRIVATE_ONLY,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'indianTribe',
    name: C.FIELD_INDIAN_TRIBE,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'isNewStatus',
    name: C.FIELD_IS_NEW_STATUS,
  },
  {
    ...commonFilterParams,
    type: 'number',
    label: 'vmtSourceId',
    name: C.FIELD_VMT_SOURCE_ID,
  },
  {
    ...commonFilterParams,
    label: 'mailingState',
    name: C.FIELD_MAILING_STATE,
  },
  {
    ...commonFilterParams,
    label: 'emailAddress',
    name: C.FIELD_EMAIL_ADDRESS,
  },
  {
    ...commonFilterParams,
    type: 'number',
    label: 'mcs150Mileage',
    name: C.FIELD_MCS150MILEAGE,
  },
  {
    ...commonFilterParams,
    type: 'number',
    label: 'nbrPowerUnit',
    name: C.FIELD_NBR_POWER_UNIT,
  },
  {
    ...commonFilterParams,
    label: 'mailingStreet',
    name: C.FIELD_MAILING_STREET,
  },
  {
    ...commonFilterParams,
    type: 'number',
    label: 'recentMileage',
    name: C.FIELD_RECENT_MILEAGE,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'exemptForHire',
    name: C.FIELD_EXEMPT_FOR_HIRE,
  },
  {
    ...commonFilterParams,
    label: 'mailingCountry',
    name: C.FIELD_MAILING_COUNTRY,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'privateProperty',
    name: C.FIELD_PRIVATE_PROPERTY,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'stateGovernment',
    name: C.FIELD_STATE_GOVERNMENT,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'localGovernment',
    name: C.FIELD_LOCAL_GOVERNMENT,
  },
  {
    ...commonFilterParams,
    label: 'contactTimeZone',
    name: C.FIELD_CONTACT_TIME_ZONE,
  },
  {
    ...commonFilterParams,
    type: 'enum',
    label: 'carrierOperation',
    name: C.FIELD_CARRIER_OPERATION,
    customFieldOptions: carrierOperationValues(),
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'federalGovernment',
    name: C.FIELD_FEDERAL_GOVERNMENT,
  },
  {
    ...commonFilterParams,
    type: 'number',
    label: 'mcs150MileageYear',
    name: C.FIELD_MCS150MILEAGE_YEAR,
  },
  {
    ...commonFilterParams,
    type: 'number',
    label: 'recentMileageYear',
    name: C.FIELD_RECENT_MILEAGE_YEAR,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'authorizedForHire',
    name: C.FIELD_AUTHORIZED_FOR_HIRE,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'privatePassengerBusiness',
    name: C.FIELD_PRIVATE_PASSENGER_BUSINESS,
  },
  {
    ...commonFilterParams,
    type: 'boolean',
    label: 'privatePassengerNonbusiness',
    name: C.FIELD_PRIVATE_PASSENGER_NONBUSINESS,
  },
];

export {
  newReportConditions,
  reportBooleanValues,
  REPORT_FILTER_PARAMS,
  REPORT_FILTER_DATE_LAST_NEXT_OPERATIONS,
};
